module.exports = __webpack_public_path__ + "img/logo.9ec2db97.png";